// Mock data for OzzieeTech redesign. Frontend-only for now.

export const company = {
  name: "OzzieeTech",
  tagline: "Technology That Powers Your Next Move",
  subtitle: "From AI-driven SEO to enterprise-grade IT support — we build, secure and scale the technology behind Australia's smartest small businesses.",
  location: "Australia",
  phone: "0469 341 430",
  phoneRaw: "0469341430",
  altPhone: "+61 491 072 992",
  whatsapp: "https://wa.me/61469341430",
  email: "hello@ozzieetech.com.au",
  hoursToday: "09:00 am \u2013 05:00 pm",
  copyright: "Copyright \u00a9 2024 OzzieeTech - All Rights Reserved.",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "SEO", path: "/seo" },
  { label: "Consulting", path: "/consulting" },
  { label: "Managed Services", path: "/managed-services" },
  { label: "Privacy Policy", path: "/privacy-policy" },
];

export const images = {
  heroTeam: "https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5",
  collaboration: "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
  meeting: "https://images.pexels.com/photos/1181370/pexels-photo-1181370.jpeg",
  cybersecurity: "https://images.pexels.com/photos/17323801/pexels-photo-17323801.jpeg",
  managed: "https://images.pexels.com/photos/4973899/pexels-photo-4973899.jpeg",
  seo1: "https://static.prod-images.emergentagent.com/jobs/b93abce1-d2aa-45ee-8132-7586b30ad8e5/images/c168be5995f279c6961ad04b3c6d70b3b20d6c4318e008ac580b154bd6800836.jpeg",
  seo2: "https://static.prod-images.emergentagent.com/jobs/b93abce1-d2aa-45ee-8132-7586b30ad8e5/images/b532e5d108a901175edbb0a72ca551642bffec63f8ca1a48910691fdc910769b.jpeg",
  consulting: "https://images.pexels.com/photos/12902865/pexels-photo-12902865.jpeg",
};

export const stats = [
  { value: "10+", label: "Years of Experience" },
  { value: "200+", label: "Projects Delivered" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "24/7", label: "Support Coverage" },
];

export const services = [
  {
    id: "seo",
    icon: "Search",
    title: "Search Engine Optimisation",
    short: "Climb the rankings with AI-powered audits, data-backed keyword strategy and ethical SEO that turns searches into sales.",
    path: "/seo",
  },
  {
    id: "consulting",
    icon: "Lightbulb",
    title: "IT Consulting",
    short: "Cloud, cybersecurity and infrastructure strategy that turns your tech stack into a genuine competitive edge.",
    path: "/consulting",
  },
  {
    id: "managed",
    icon: "ServerCog",
    title: "Managed Services",
    short: "24/7 monitoring, ironclad security and instant support — your entire IT stack handled, so downtime never slows you down.",
    path: "/managed-services",
  },
];

export const whoWeAre = [
  {
    title: "Our Story",
    body: "For over a decade, OzzieeTech has been the engine room behind growing businesses — delivering SEO, IT consulting and managed services that punch well above their weight. What started as a passion for technology is now a track record of measurable wins for our clients.",
    img: "https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5",
  },
  {
    title: "Our Expertise",
    body: "Network architecture, cybersecurity, cloud migration, AI-assisted SEO, managed support — our engineers cover the full stack. We invest in staying ahead of the curve so the technology we deploy today still performs tomorrow.",
    img: "https://images.pexels.com/photos/17323801/pexels-photo-17323801.jpeg",
  },
  {
    title: "Our Clients",
    body: "From fast-moving startups to established firms, businesses across every industry trust us as their technology partner. They stay because we treat their systems like our own — personal, proactive and relentlessly focused on their success.",
    img: "https://images.pexels.com/photos/1181370/pexels-photo-1181370.jpeg",
  },
];

export const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Owner, Capital Cafe Group",
    quote: "OzzieeTech transformed how we run our technology. Their managed services mean we never worry about downtime anymore.",
  },
  {
    name: "James Patterson",
    role: "Director, Patterson Legal",
    quote: "Their SEO work doubled our enquiries within months. Honest, transparent and genuinely focused on results.",
  },
  {
    name: "Aisha Khan",
    role: "Founder, BrightStart Childcare",
    quote: "The consulting team understood our business goals from day one and delivered practical, affordable solutions.",
  },
];

export const seoComponents = [
  { num: "01", title: "Keyword Research", body: "Identifying and targeting relevant keywords that potential customers use when searching for products, services, or information." },
  { num: "02", title: "On-Page SEO", body: "Optimizing individual web pages to rank higher and earn more relevant traffic \u2014 content, meta tags, headings, URL structure and images." },
  { num: "03", title: "Off-Page SEO", body: "Building authority and credibility through external means, such as backlinks, social media signals, and brand mentions." },
  { num: "04", title: "Technical SEO", body: "Ensuring a website is properly indexed and accessible \u2014 site speed, mobile-friendliness, XML sitemaps, robots.txt and HTTPS." },
  { num: "05", title: "Content Quality", body: "Creating high-quality, valuable, and engaging content that meets the needs and interests of the target audience." },
  { num: "06", title: "User Experience", body: "Enhancing the overall experience for visitors \u2014 easy navigation, fast loading times, and a responsive design." },
  { num: "07", title: "Analytics & Reporting", body: "Monitoring and analyzing performance with Google Analytics and Search Console to measure traffic, conversions and key metrics." },
];

export const seoHighlights = [
  { icon: "Users", title: "Extension to Your Team", body: "We focus on collaboration throughout the lifespan of our engagement. We align our strategy with your business goals to achieve real business results." },
  { icon: "Target", title: "Strategy", body: "Effective SEO strategy prioritises keywords that contribute significantly to profit \u2014 quality traffic, high-margin products and the best quality leads." },
  { icon: "PiggyBank", title: "Affordable SEO", body: "Cost-effective strategies that improve visibility without breaking the bank. Set a clear budget, stick to ethical practices and focus on local SEO." },
];

export const consultingAreas = [
  { icon: "Map", title: "Strategy & Planning", body: "Developing IT strategies aligned with business goals, including technology roadmaps, digital transformation plans, and IT governance frameworks." },
  { icon: "Workflow", title: "System Integration", body: "Assisting with the implementation and integration of new systems and technologies, ensuring they work seamlessly with existing infrastructure." },
  { icon: "ShieldCheck", title: "Cybersecurity", body: "Advising on security strategies, risk assessments, and compliance with regulations to protect against cyber threats." },
  { icon: "Server", title: "Infrastructure Management", body: "Optimizing IT infrastructure including hardware, software, networks, and cloud services to improve efficiency and performance." },
  { icon: "BarChart3", title: "Data & Analytics", body: "Expertise in data storage, processing, analysis, and visualization to support data-driven decision-making." },
  { icon: "Code2", title: "Software Development", body: "Designing and developing custom software solutions tailored to the client's specific needs." },
  { icon: "ClipboardList", title: "Project Management", body: "Overseeing IT projects from planning to execution, ensuring they are completed on time and within budget." },
  { icon: "LifeBuoy", title: "IT Support & Maintenance", body: "Offering ongoing support and maintenance services for IT systems and applications." },
];

export const managedServices = [
  { icon: "Activity", title: "Proactive Monitoring", body: "We monitor IT systems, networks, and devices around the clock to identify and address issues before they cause downtime \u2014 including maintenance, updates and patches." },
  { icon: "Headset", title: "Help Desk & Support", body: "Providing technical support to end-users, including troubleshooting and resolving issues with hardware, software, and network connectivity." },
  { icon: "Lock", title: "Security Management", body: "Implementing and managing security measures \u2014 firewalls, antivirus, intrusion detection, and SIEM solutions \u2014 to protect against cyber threats." },
  { icon: "DatabaseBackup", title: "Backup & Disaster Recovery", body: "Ensuring data is regularly backed up and can be quickly restored in the event of data loss, hardware failure, or other disasters." },
  { icon: "Network", title: "Network Management", body: "Managing and optimizing network performance, including network design, configuration, and monitoring." },
  { icon: "Cloud", title: "Cloud Services", body: "Managing cloud infrastructure, applications, and services, including cloud migration, optimization, and security." },
  { icon: "Compass", title: "IT Strategy & Consulting", body: "Providing strategic advice on IT planning, budgeting, and technology investments to align with business goals." },
  { icon: "FileCheck", title: "Compliance Support", body: "Assisting with compliance requirements and ensuring IT systems adhere to relevant laws and regulations." },
];

export const privacySections = [
  { title: "Information We Collect", body: "We collect information you provide directly to us, such as when you fill out a contact form, subscribe to our newsletter, or communicate with us. This may include your name, email address, phone number and message content." },
  { title: "How We Use Your Information", body: "We use the information we collect to respond to your enquiries, provide and improve our services, send you relevant updates, and analyse website traffic to optimise your experience." },
  { title: "Cookies", body: "We use cookies to analyze website traffic and optimize your website experience. By accepting our use of cookies, your data will be aggregated with all other user data." },
  { title: "Data Security", body: "We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure or destruction." },
  { title: "Your Rights", body: "You have the right to access, correct or delete the personal information we hold about you. To exercise these rights, please contact us using the details provided on this website." },
  { title: "Contact Us", body: "If you have any questions about this Privacy Policy, please contact us at hello@ozzieetech.com.au or call 0469 341 430." },
];
